const app = import.meta.env.VITE_APP_NAME ?? 'default'
const modules = import.meta.glob('./apps/*.js')
if (modules[`./apps/${app}.js`]) {
  modules[`./apps/${app}.js`]().then(({ default: boot }) => boot())
} else {
  alert(`Application ${app} does not exist`)
}
